import { useMemo } from "react";
import type { JobItem } from "@kanda-libs/ks-frontend-services";
import { useSelector } from "react-redux";
import jobSelectors from "store/selectors/job";

export interface ListPropsHook {
  lineItems?: JobItem[];
}

export default function useListProps(): ListPropsHook {
  const job = useSelector(jobSelectors.getEntity);

  const lineItems = useMemo(
    () =>
      job?.job_items.map((item, index) => ({
        key: `item-${index}`,
        ...item,
      })),
    [job]
  );

  return {
    lineItems,
  };
}
